import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logos/logo.png'
import _imports_1 from '@/assets/images/icons/icon-linkedin.svg'
import _imports_2 from '@/assets/images/icons/icon-x.svg'
import _imports_3 from '@/assets/images/icons/icon-facebook.svg'
import _imports_4 from '@/assets/images/icons/icon-whatsapp.svg'
import _imports_5 from '@/assets/images/icons/icon-download.svg'


const _withScopeId = n => (_pushScopeId("data-v-9c4ddd94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background-container" }, null, -1))
const _hoisted_3 = { class: "full-width" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "topbar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "logo",
    alt: "logo"
  })
], -1))
const _hoisted_5 = { class: "upper-title" }
const _hoisted_6 = { class: "video" }
const _hoisted_7 = ["src", "poster"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "description" }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "line left" })
], -1))
const _hoisted_12 = { class: "share" }
const _hoisted_13 = { class: "share-title" }
const _hoisted_14 = { class: "desktop-share" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Share on linkedin",
  class: "icon"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "LinkedIn", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Share on X",
  class: "icon"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "X", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "Share on facebook",
  class: "icon"
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Facebook", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "Share on whatsapp",
  class: "icon"
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Whatsapp", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "download-holder" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "Download video",
  class: "icon"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("title")), 1),
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", {
          class: "video-box",
          id: "video-box",
          style: _normalizeStyle(`min-height: ${_ctx.boxHeight}px;`)
        }, [
          _createElementVNode("video", {
            id: "video",
            ref: "video",
            class: "video",
            controlsList: "nofullscreen",
            controls: "",
            src: _ctx.video,
            poster: _ctx.thumbnail
          }, null, 8, _hoisted_7),
          _createElementVNode("img", {
            id: "format",
            class: "format",
            src: _ctx.format,
            alt: "video format"
          }, null, 8, _hoisted_8)
        ], 4),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("paragraph1")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("paragraph2")), 1),
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("paragraph3")) + " ", 1),
            _createElementVNode("a", {
              href: _ctx.$t('link.href')
            }, _toDisplayString(_ctx.$t("link.copy")), 9, _hoisted_10)
          ])
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("share")), 1),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "button linkedin",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleShare('linkedin')))
            }, _hoisted_17),
            _createElementVNode("div", {
              class: "button x",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleShare('x')))
            }, _hoisted_20),
            _createElementVNode("div", {
              class: "button facebook",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleShare('facebook')))
            }, _hoisted_23),
            _createElementVNode("div", {
              class: "button whatsapp",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleShare('whatsapp')))
            }, _hoisted_26)
          ]),
          _createVNode(_component_Divider, {
            copy: _ctx.$t('share_alternative')
          }, null, 8, ["copy"]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", {
              class: "button download",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleShare('download')))
            }, [
              _hoisted_28,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("download")), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}